import React from 'react'
import { unSlugify } from '../../utils'

const ExeatTypePill = ({type}) => {
  return (
    <span className={`inline-block text-xs px-2 py-1 rounded 
    ${type === 'other' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
    ${type === 'holiday' && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
    ${type === 'medical' && 'bg-red-600 text-red-800 bg-opacity-10 font-outfit capitalize'}
    ${type === 'religious' && 'bg-blue-600 text-blue-800 bg-opacity-10 font-outfit capitalize'}
    `}>{unSlugify(type?.toLowerCase())}</span>
  )
}

export default  ExeatTypePill